/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class NextGenReportCreateRequest {
    getFixupPrototypeFunction() { return NextGenReportCreateRequest.fixupPrototype; }

    static newInstance(model: Partial<NextGenReportCreateRequest>): NextGenReportCreateRequest {
        let obj = Object.assign(new NextGenReportCreateRequest(), model);
        NextGenReportCreateRequest.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<NextGenReportCreateRequest>): NextGenReportCreateRequest {
        if (!model) return null;
        return NextGenReportCreateRequest.newInstance(<NextGenReportCreateRequest> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: NextGenReportCreateRequest) {
        if (!obj) return;

        models.NextGenReportCreateRequest.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: NextGenReportCreateRequest): boolean {
        Object.setPrototypeOf(obj, NextGenReportCreateRequest.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.configuration) {
            models.ConfigurationForNextGenReportBase.fixupPrototype(this.configuration);
        }
    }

    /**
     * Report configuration to generate report
     */
    configuration: models.ConfigurationForNextGenReportBase;

}
